import React from "react";
import { Helmet } from "react-helmet";
import { Hero } from "../../../components/Web";

export function Contact() {
  return (
    <>
      <Helmet>
        <title>Inversiones Catelli | Contactanos</title>
        <meta
          name="description"
          content="Contactanos | Somos Catelli "
          data-react-helmet="true"
        />
      </Helmet>
      <section className="hero__secciones">
        <Hero seccion={"contact"} />
      </section>
      <section className="container mx-auto mt-4 md:w-1/2 md:flex md:space-x-6 justify-evenly mb-8">
        <div className="w-full">
          <h2 className="text-4xl font-semibold">Contactanos</h2>
          <p className="text-lg font-secondary mt-2">¿Como podemos ayudar?</p>
          <div className="mt-2">
            <div>
              <div>Nombre</div>
              <input className="form-control" />
            </div>
            <div>
              <div>Correo</div>
              <input className="form-control" />
            </div>
            <div>
              <div>Asunto</div>
              <input className="form-control" />
            </div>
            <div>
              <div>Comentario</div>
              <textarea
                class="form-control  hover:bg-white focus:outline-none focus:shadow-outline"
                name="comentario"
                id=""
                cols="30"
                rows="10"
                placeholder="Tu comentarios son importante."
              ></textarea>
            </div>
            <div>
              <button class="btn btn-primary mx-auto text-white">Enviar</button>
            </div>
          </div>
        </div>
        <div className="w-full m-0 mt-4">
          <iframe
            className="w-full h-full mb-8"
            id="gmap_canvas"
            title="YouTube video player"
            src="https://maps.google.com/maps?q=Inversiones%20Catelli&t=&z=13&ie=UTF8&iwloc=&output=embed"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
          ></iframe>
        </div>
      </section>
    </>
  );
}
